/**
* - Replace any instances of "widgetType: 'Section'" in any layout items with "sectionType: 'Section'"
* - If for some reason the item is a 'sectionRow' without a sectionType, add the default "sectionType: 'Section'".
*/
export default function layoutItemMigrations(layoutItems) {
  let newLayoutItems = {};

  Object.keys(layoutItems).forEach(id => {
    const newLayoutItem = { ...layoutItems[id] };

    // Convert any "widgetType: 'Section'" with "sectionType: 'Section'"
    if (newLayoutItem.widgetType && newLayoutItem.widgetType === 'Section') {
      delete newLayoutItem.widgetType;
      newLayoutItem.sectionType = 'Section';
    }

    // If for some reason the item is a 'sectionRow' without a sectionType, add the default "sectionType: 'Section'".
    if (!newLayoutItem.sectionType && newLayoutItem.layout.type === 'sectionRow') {
      newLayoutItem.sectionType = 'Section';
    }
    newLayoutItems[id] = newLayoutItem;
  });

  return newLayoutItems;
}
